import { RegisterDateType } from '../../types';

export const calculateRegister = (data: RegisterDateType[]) => {
  return data.reduce(
    (acc, item) => {
      acc.payment += item.total_payment
      acc.qty_order += item.qty_order
      acc.qty_delivered += item.qty_delivered
      acc.total += item.total
      return acc;
    },
    {
      total: 0,
      payment: 0,
      balance: 0,
      qty_order:0,
      qty_delivered:0
    },
  );
};
